import React from 'react';
import Button from '~/components/atoms/button/button';
import ChevronIcon from '~/components/atoms/icon/chevron/ChevronIcon';
import scrollToElement from '~/utils/scrollToElement';
import styles from './scrollToTopButton.module.scss';

interface IScrollToTopButton {
    headerRef: React.RefObject<HTMLDivElement>;
    showSERPContent: boolean;
}

const ScrollToTopButton: React.FC<IScrollToTopButton> = ({ headerRef, showSERPContent }) => {
    const handleClick = () => {
        if (headerRef && headerRef.current) {
            scrollToElement(headerRef.current);
        }
    };

    if (!showSERPContent) {
        return null;
    }

    return (
        <Button className={styles.scrollToTopButton} onclick={handleClick} data-testid="scroll-to-top">
            <ChevronIcon width={8} height={8} direction={'up'} />
        </Button>
    );
};

export default ScrollToTopButton;
